module.exports = __webpack_public_path__ + "img/22.2f0a3a6a.jpg";